module.exports = __webpack_public_path__ + "gitlab-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/gitlab-logo.png
// module id = 1256
// module chunks = 74